import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import React from 'react';
import { getInlineStyles } from '../../utils/styles';
import { TLottieAnimationViewProps } from './LoadingAnimationView';
import { useLottieColorSlot } from './useLottieColorSlot';

const logoSuccess = new URL('../../animations/LOGO_SUCCESS.lottie', import.meta.url).href;

export const SuccessAnimationView = ({ uid, animationsColor, margin }: TLottieAnimationViewProps) => {
    const dotLottieRefCallback = useLottieColorSlot(animationsColor);

    return (
        <div data-test={uid} style={getInlineStyles({ margin, height: '73px', width: '73px' })}>
            <DotLottieReact src={logoSuccess} loop={false} autoplay dotLottieRefCallback={dotLottieRefCallback} />
        </div>
    );
};
